import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
		providedIn: 'root'
	})
export class ProprieteService {

	private url = 'ws/admin/app-properties';

	constructor(private http: HttpClient) {
	}

	lister(): Observable<any> {
		return this.http.get(this.url);
	}
}
